<template>
  <div id="insightsPeople">
    <div class="margin-subpages">
      <div class="flex">
        <el-select v-model="selectTeam" filterable placeholder="Select" class="input-style"
        :class="[ blurMode ?  'blurelement': '' ]">
          <el-option v-if="user.user_type !== 'leadership'" class="text-dropdown"
            :value="`All Teams (${optionsTeam.length})`"></el-option>
          <el-option class="text-dropdown" 
          :class="[ blurMode ?  'blurelement': '' ]"
          v-for="item in optionsTeam" :key="item.key" :label="item.name"
            :value="item.key"></el-option>
        </el-select>
        <el-input class="input-style ml-24" style="font-size: 18px; width: 220px !important" autosize
          :placeholder="$t('global.Search')" v-model="inputSearch" clearable></el-input>
        <div class="flex-center flex-1" style="justify-content: flex-end">
          <div class="flex-center">
            <img class="dispTalentTypeStyle" :style="'width: ' + (disp_talentType == 'All_Types')
                ? '84px;'
                : '110px;'
              " :src="getImgPeopleUrl(disp_talentType)" />
          </div>
          <el-dropdown trigger="click" :hide-on-click="false" ref="dropdownMenu">
            <img @click="dropdownTalentTypeClick" style="cursor: pointer" src="@/assets/images/filter-list-24px.png" />
            <el-dropdown-menu slot="dropdown">
              <div class="dropdownHeader">
                <div>
                  <el-button @click="handleSelectAll" class="dropdownHeaderTextStyle" type="text">{{
                    $t("insights.Select_all") }}</el-button>
                  <el-button @click="checkedTalentType = []" class="dropdownHeaderTextStyle" style="margin-left: 24px"
                    type="text">{{ $t("insights.Clear") }}</el-button>
                </div>
                <el-tooltip effect="dark" placement="top">
                  <div class="tooltipStyle" slot="content">
                    {{ $t("insights.Talent_Types_are_tagged") }}
                  </div>
                  <div class="flex-center">
                    <img :src="getImgUrl('help_outline-16px')" />
                  </div>
                </el-tooltip>
              </div>
              <div class="dropdownItem-insightsPeople">
                <el-checkbox-group v-model="checkedTalentType">
                  <el-dropdown-item v-for="item in talentTypeOption" :key="item.type">
                    <el-checkbox :label="item.type" :key="item.type">{{ item.type }} ({{ item.count }})</el-checkbox>
                  </el-dropdown-item>
                </el-checkbox-group>
              </div>
              <div class="dropdownFooter">
                <el-button @click="cancelTalentType" type="cancel">{{
                  $t("insights.Cancel")
                }}</el-button>
                <el-button @click="saveTalentType" type="save">{{
                  $t("insights.Okay")
                }}</el-button>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="split-risk-power">
        <div class="risk-container">
          <div class="flex-center mb-24">
            <div class="fs-16 fw-700">
              {{ $t("insights.People_Impact_and") }}
            </div>
            <div class="flex-center ml-auto mr-6">
              <div class="risk-title one"></div>
              <div class="risk-title two"></div>
              <div class="risk-title three"></div>
            </div>
            <div class="fs-11 opa-08">{{ $t("insights.RISK_LEVELS") }}</div>
            <div class="risk-title line ml-12 mr-6"></div>
            <div class="fs-11 opa-08">
              {{ $t("insights.AVG_IMPACT_RATING") }}
            </div>
          </div>
          <div class="relative" style="height: 210px">
            <div v-if="loadingDataChart" class="absolute-mid">
              <loading-even></loading-even>
            </div>
            <div class="" style="height: 210px; width: 552px">
              <canvas ref="impactLinechart"></canvas>
            </div>
            <div class="absolute-mid" style="height: 210px; width: 552px">
              <canvas ref="riskAndStartBarchart"></canvas>
            </div>
          </div>
        </div>
        <div class="power-container">
          <div class="flex-center mb-14">
            <el-dropdown @command="handlePowerPick">
              <span class="el-dropdown-link">
                {{ PowerSkillShowingData
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="width: 140px">
                <!-- <el-dropdown-item command="Power Skills">{{
                  $t("insights.Power_Skills")
                }}</el-dropdown-item> -->
                <el-dropdown-item command="Talent Type">{{
                  $t("insights.Talent_Type")
                }}</el-dropdown-item>
                <el-dropdown-item command="Network Type">{{
                  $t("insights.Network_Type")
                }}</el-dropdown-item>
                <!-- <el-dropdown-item command="Excels At">{{
                  $t("insights.Excels_At")
                }}</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <div class="ml-auto" v-if="PowerSkillShowingData == 'Power Skills'"> -->
            <!-- <el-dropdown @command="handleTimePick">
                <span class="el-dropdown-link">
                  {{ timeShowingData
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="width: 140px">
                  <el-dropdown-item command="By month"
                    >By month</el-dropdown-item
                  >
                  <el-dropdown-item command="By years"
                    >By years</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown> -->
            <!-- </div> -->
          </div>

          <!-- <div v-if="PowerSkillShowingData == 'Power Skills'">
            <div v-if="loadingDataChart">
              <div v-for="data in [1, 2, 3, 4, 5, 6]" :key="data + '_bar_loading'"
                class="power-tabs flex-center image-skeleton opa-05"></div>
            </div>
            <div
              v-else
              v-for="data in powerChartData"
              :key="data.label + '_bar'"
              :class="`power-tabs flex-center`"
            >
              <div
                :class="`color-bar ${data.icon}`"
                :style="`width: ${setBarWidth(
                  data.point,
                  data.point_total
                )}px;`"
              ></div>
              <div class="relative">{{ data.label }}</div>
              <div class="ml-auto relative">
                {{
                  data.point_total > 0
                    ? Math.round((data.point / data.point_total) * 100)
                    : 0
                }}%
              </div>
            </div>
          </div> -->

          <div v-if="PowerSkillShowingData == 'Talent Type'" class="network-container relative"
            style="min-height: 200px">
            <div v-if="loadingDataChart" class="absolute-mid">
              <loading-even></loading-even>
            </div>
            <div v-else class="flex">
              <div class="text-left-table">
                <div class="text" style="width: 150px; left: -24px">
                  {{ $t("insights.INDIVIDUAL_PERFORMANCE") }}
                </div>
              </div>
              <div class="grid-table">
                <el-tooltip :content="$t('category.Talent_Types.Untapped_Potential')" placement="top">
                  <div class="cell flex-mid c-FBC02D">
                    {{
                      talentChartData && talentChartData["Untapped Potential"]
                      ? talentChartData["Untapped Potential"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Activated')" placement="top">
                  <div class="cell flex-mid c-C2E337">
                    {{
                      talentChartData && talentChartData["Activated"]
                      ? talentChartData["Activated"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.High_Performer')" placement="top">
                  <div class="cell flex-mid c-66BB6A">
                    {{
                      talentChartData && talentChartData["High Performer"]
                      ? talentChartData["High Performer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Superstar')" placement="top">
                  <div class="cell flex-mid c-66BB6A">
                    {{
                      talentChartData && talentChartData["Superstar"]
                      ? talentChartData["Superstar"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Talent_Types.Valued_Contributor')" placement="top">
                  <div class="cell flex-mid c-FBC02D">
                    {{
                      talentChartData && talentChartData["Valued Contributor"]
                      ? talentChartData["Valued Contributor"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Key_Player')" placement="top">
                  <div class="cell flex-mid c-C2E337">
                    {{
                      talentChartData && talentChartData["Key Player"]
                      ? talentChartData["Key Player"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Respected_Expert')" placement="top">
                  <div class="cell flex-mid c-66BB6A">
                    {{
                      talentChartData && talentChartData["Respected Expert"]
                      ? talentChartData["Respected Expert"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Distinguished_Talent')" placement="top">
                  <div class="cell flex-mid c-66BB6A">
                    {{
                      talentChartData && talentChartData["Distinguished Talent"]
                      ? talentChartData["Distinguished Talent"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Talent_Types.Community_Pillar')" placement="top">
                  <div class="cell flex-mid c-EF8D3A">
                    {{
                      talentChartData && talentChartData["Community Pillar"]
                      ? talentChartData["Community Pillar"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Engaged_Contributor')" placement="top">
                  <div class="cell flex-mid c-EF8D3A">
                    {{
                      talentChartData && talentChartData["Engaged Contributor"]
                      ? talentChartData["Engaged Contributor"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Core_Player')" placement="top">
                  <div class="cell flex-mid c-C2E337">
                    {{
                      talentChartData && talentChartData["Core Player"]
                      ? talentChartData["Core Player"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Solid_Performer')" placement="top">
                  <div class="cell flex-mid c-C2E337">
                    {{
                      talentChartData && talentChartData["Solid Performer"]
                      ? talentChartData["Solid Performer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Talent_Types.Up_and_coming')" placement="top">
                  <div class="cell flex-mid c-EF8D3A">
                    {{
                      talentChartData && talentChartData["Up-and-Coming"]
                      ? talentChartData["Up-and-Coming"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Rising_Star')" placement="top">
                  <div class="cell flex-mid c-EF8D3A">
                    {{
                      talentChartData && talentChartData["Rising Star"]
                      ? talentChartData["Rising Star"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Emerging_Talent')" placement="top">
                  <div class="cell flex-mid c-FBC02D">
                    {{
                      talentChartData && talentChartData["Emerging Talent"]
                      ? talentChartData["Emerging Talent"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.High_Potential')" placement="top">
                  <div class="cell flex-mid c-FBC02D">
                    {{
                      talentChartData && talentChartData["High Potential"]
                      ? talentChartData["High Potential"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                
                <el-tooltip :content="$t('category.Talent_Types.Starter')" placement="top">
                  <div class="cell flex-mid c-F44336">
                    {{
                      talentChartData && talentChartData["Latent Potential"]
                      ? talentChartData["Latent Potential"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Contributor')" placement="top">
                  <div class="cell flex-mid c-EF8D3A">
                    {{
                      talentChartData && talentChartData["Contributor"]
                      ? talentChartData["Contributor"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Crowd_Favorite')" placement="top">
                  <div class="cell flex-mid c-EF8D3A">
                    {{
                      talentChartData && talentChartData["Crowd Favorite"]
                      ? talentChartData["Crowd Favorite"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Unsung_Talent')" placement="top">
                  <div class="cell flex-mid c-FBC02D">
                    {{
                      talentChartData && talentChartData["Unsung Talent"]
                      ? talentChartData["Unsung Talent"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
              </div>
            </div>
            <div v-if="!loadingDataChart" class="fs-11 opa-08 pt-12 pl-32 fc-000000 center">
              {{ $t("insights.NETWORK_EFFECTIVENESS") }}
            </div>
          </div>
          <div v-else-if="PowerSkillShowingData == 'Network Type'" class="network-container">
            <div class="flex">
              <div class="text-left-table">
                <div class="text">{{ $t("insights.OUTER_NETWORK") }}</div>
              </div>
              <div class="grid-table">
                <el-tooltip :content="$t('category.Network_type.Super_Outer')" placement="top">
                  <div class="cell flex-mid c-C2E337" style="margin-right: 0; padding-right: 4px; width: 83px">
                    {{
                      networkChartData && networkChartData["Super Outer"]
                      ? networkChartData["Super Outer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <div class="cell"></div>
                <el-tooltip :content="$t('category.Network_type.Super_Network')" placement="top">
                  <div class="cell flex-mid c-66BB6A" style="
                      margin-right: 0;
                      padding-right: 4px;
                      border-radius: 4px 0 0 4px;
                    "></div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Super_Network')" placement="top">
                  <div class="cell flex-mid c-66BB6A" style="
                      margin-bottom: 0;
                      padding-bottom: 4px;
                      border-radius: 0 4px 0 0;
                    ">
                    {{
                      networkChartData && networkChartData["Super Network"]
                      ? networkChartData["Super Network"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Network_type.High_Outer')" placement="top">
                  <div class="cell flex-mid c-FBC02D" style="margin-right: 0; padding-right: 4px; width: 83px">
                    {{
                      networkChartData && networkChartData["High Outer"]
                      ? networkChartData["High Outer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <div class="cell"></div>
                <el-tooltip :content="$t('category.Network_type.High_Network')" placement="top">
                  <div class="cell flex-mid c-C2E337">
                    {{
                      networkChartData && networkChartData["High Network"]
                      ? networkChartData["High Network"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Super_Network')" placement="top">
                  <div class="cell flex-mid c-66BB6A" style="border-radius: 0 0 4px 4px"></div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Network_type.Medium_Outer')" placement="top">
                  <div class="cell flex-mid c-EF8D3A">
                    {{
                      networkChartData && networkChartData["Medium Outer"]
                      ? networkChartData["Medium Outer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Medium_Network')" placement="top">
                  <div class="cell flex-mid c-EF8D3A">
                    {{
                      networkChartData && networkChartData["Medium Network"]
                      ? networkChartData["Medium Network"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.High_Inner')" placement="top">
                  <div class="cell center flex-mid c-FBC02D" style="
                      margin-bottom: 0;
                      padding-bottom: 4px;
                      border-radius: 4px 4px 0 0;
                    ">
                    <div class="min-of-cell-2">
                      {{
                        networkChartData && networkChartData["High Inner"]
                        ? networkChartData["High Inner"]
                        : 0
                      }}
                    </div>
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Super_Inner')" placement="top">
                  <div class="cell center c-C2E337" style="
                      margin-bottom: 0;
                      padding-bottom: 4px;
                      border-radius: 4px 4px 0 0;
                    ">
                    <div class="min-of-cell-2">
                      {{
                        networkChartData && networkChartData["Super Inner"]
                        ? networkChartData["Super Inner"]
                        : 0
                      }}
                    </div>
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Network_type.Low_Network')" placement="top">
                  <div class="cell flex-mid c-F44336">
                    {{
                      networkChartData && networkChartData["Low Network"]
                      ? networkChartData["Low Network"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Medium_Inner')" placement="top">
                  <div class="cell flex-mid c-EF8D3A">
                    {{
                      networkChartData && networkChartData["Medium Inner"]
                      ? networkChartData["Medium Inner"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.High_Inner')" placement="top">
                  <div class="cell flex-mid c-FBC02D" style="border-radius: 0 0 4px 4px"></div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Super_Inner')" placement="top">
                  <div class="cell flex-mid c-C2E337" style="border-radius: 0 0 4px 4px"></div>
                </el-tooltip>
              </div>
            </div>
            <div class="fs-10 opa-06 pt-12 pl-32 center">
              {{ $t("insights.INNER_NETWORK") }}
            </div>
          </div>

          <!-- <div v-else-if="PowerSkillShowingData == 'Excels At'" style="height: 228px" class="thin-scrollbar pr-4">
            <div v-for="(value, index) in excelsAtDataChart" :key="`${index}_${value.label}`" class="excels-card">
              <div class="flex-center fs-13 fc-000000">
                <div class="opa-06">{{ index + 1 }}</div>
                <div class="ml-6 fw-700 ellipsis mr-6">{{ value.label }}</div>
                <div class="ml-auto opa-08">{{ value.userCount }}</div>
                <i class="el-icon-user-solid fc-6C30CC opa-08 ml-4"></i>
                <div class="percent-tag ml-4">
                  <div class="percent" :style="`width: ${setBarExcelsWidth(value.percentage)}px;`"></div>
                </div>
                <div style="width: 20px" class="cursor-pointer" @click="value.expand = !value.expand">
                  <i v-if="value.expand" class="el-icon-arrow-up ml-4"></i>
                  <i v-else class="el-icon-arrow-down ml-4"></i>
                </div>
              </div>
              <div v-if="value.expand" class="expend-user flex-center">
                <div v-for="(user, i) in value.topUser" :key="user.userId">
                  <div class="user-cell" v-if="i < 3">
                    <div class="flex-center" v-if="user.imageProfile">
                      <img v-lazy="user.imageProfile" :key="user.imageProfile" class="image-skeleton image-profile-40" />
                    </div>
                    <div v-else class="image image-profile-40">
                      <div class="text-in-image text-in-image-40 flex-mid">
                        {{ $utils("acronymName", { fullName: user.fullname }) }}
                      </div>
                    </div>
                    <div class="count-excels">
                      {{ user.excelsCount }}
                    </div>
                  </div>
                </div>
                <div class="ml-auto fs-12 fw-700 cursor-pointer" style="color: #006772"
                  @click="viewListClick(value.label)">
                  {{ $t("insights.view_list") }}
                </div>
              </div>
            </div>
          </div> -->

        </div>
      </div>

      <div class="flex-center mt-24">
        <div class="flex-1">
          <span class="fs-18 fw-700">{{
            $t("insights.PEOPLE_INTELLIGENCE")
          }}</span>
        </div>
        <div style="padding-right: 12px">
          <span class="fc-000000 fs-14">{{ $t("insights.Sort_By") }}</span>
        </div>
        <div class="showOption">
          <el-menu class="el-menu-demo menuOptionStyle" mode="horizontal" style="width: 250px">
            <el-submenu index="0" style="width: 250px">
              <template slot="title">
                <span class="txtOptionStar" id="sortBy">{{
                  $t("insights.Highest_Risk_Level")
                }}</span>
              </template>
              <el-menu-item index="1" @click="sortBy('highest_risk')" style="font-size: 14px; width: 250px">{{
                $t("insights.Highest_Risk_Level") }}</el-menu-item>
              <el-menu-item index="2" @click="sortBy('lowest_risk')" style="font-size: 14px; width: 250px">{{
                $t("insights.Lowest_Risk_Level") }}</el-menu-item>
              <el-menu-item index="3" @click="sortBy('highest_star')" style="font-size: 14px; width: 250px">{{
                $t("insights.Highest_Star_Count") }}</el-menu-item>
              <el-menu-item index="4" @click="sortBy('lowest_star')" style="font-size: 14px; width: 250px">{{
                $t("insights.Lowest_Star_Count") }}</el-menu-item>
              <el-menu-item index="5" @click="sortBy('highest_impact')" style="font-size: 14px; width: 250px">{{
                $t("insights.Highest_Impact_Rating") }}</el-menu-item>
              <el-menu-item index="6" @click="sortBy('lowest_impact')" style="font-size: 14px; width: 250px">{{
                $t("insights.Lowest_Impact_Rating") }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <!-- Impact Rating Display Toggle -->
        <div class="flex-center ml-12">
          <span class="fs-14 mr-8">Score</span>
          <div class="switch-contrainer-small">
            <input
              type="checkbox"
              id="impactDisplayToggle"
              class="input-checkbox"
              v-model="showImpactPercentile"
            />
            <label for="impactDisplayToggle" class="lable-checkbox"></label>
          </div>
          
          <!-- Make the Percentile text a dropdown only when a specific team is selected -->
          <template v-if="showImpactPercentile">
            <!-- If a specific team is selected, show dropdown options -->
            <el-dropdown 
              v-if="!isAllTeamsSelected" 
              trigger="click" 
              @command="handlePercentileScope" 
              class="ml-8"
            >
              <span class="el-dropdown-link cursor-pointer fs-14">
                Percentile <span class="percentile-type">({{ percentileScopeShortText }})</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="filtered">{{ $t("insights.Scoped") }}</el-dropdown-item>
                <el-dropdown-item command="global">{{ $t("insights.Global") }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- If All Teams view, just show Percentile text -->
            <span v-else class="fs-14 ml-8">Percentile</span>
          </template>
          <span v-else class="fs-14 ml-8">Percentile</span>
        </div>
      </div>



      <div class="divTable mt-24">
        <div class="flex-center cursor-pointer">
          <el-tooltip content="Employee name, department, and current wellness status based on recent feedback" placement="top" effect="light">
            <div class="ml-24" style="width: 180px;">
              <div class="fs-11 fw-700">Name and Team</div>
              <div class="fs-10">Health Indicator</div>
            </div>
          </el-tooltip>
          
          <el-tooltip content="Recognition from peers and performance evaluation by managers" placement="top" effect="light">
            <div class="flex-column cursor-pointer" style="width: 120px;align-items: center;">
              <div class="fs-11 fw-700">Contributions</div>
              <div class="fs-10">Recognition</div>
            </div>
          </el-tooltip>
          
          <el-tooltip content="Employee's talent classification and organizational network reach" placement="top" effect="light">
            <div class="flex-column cursor-pointer" style="width: 270px;align-items: center;">
              <div class="fs-11 fw-700">Talent & Network</div>
              <div class="fs-10">Organizational Positioning</div>
            </div>
          </el-tooltip>
          
          <el-tooltip content="Recognitions earned through medals and high peer feedback ratings" placement="top" effect="light">
            <div class="flex-column cursor-pointer" style="width: 100px;align-items: center;">
              <div class="fs-11 fw-700">Achievements</div>
              <div class="fs-10">Medals & Peer Ratings</div>
            </div>
          </el-tooltip>
          
          <el-tooltip content="Assessment of employee's proficiency in key skills and alignment with company values" placement="top" effect="light">
            <div class="flex-column cursor-pointer" style="width: 110px;align-items: center;">
              <div class="fs-11 fw-700">Alignment</div>
              <div class="fs-10">Skills & Values</div>
            </div>
          </el-tooltip>
          
          <el-tooltip content="Overall performance score with weekly change indicator" placement="top" effect="light">
            <div class="flex-column cursor-pointer" style="width: 110px;align-items: center;">
              <div class="fs-11 fw-700">Impact Rating</div>
              <div class="fs-10">Overall Score</div>
            </div>
          </el-tooltip>
        </div>
        <!-- card -->
        <div v-for="(val, index) in starperform" :key="index + 'card'">
          <div class="box-card-table" :class="{
          'recovery': val.risk_level === '0',
          'risk low': val.risk_level === '1',
          'risk medium': val.risk_level === '2',
          'risk high': val.risk_level === '3'
        }">
            <el-tooltip v-if="['0', '1', '2', '3'].includes(val.risk_level)" :content="val.risk_due" placement="left">
  <img :src="getHealthIndicatorImage(val.risk_level)" class="health-indicator"/>
</el-tooltip>
            <div class="flex-column ml-12" style=" justify-content: center;min-height: 53px;width:200px;">
              <div>
                <div class="flex-center cursor-pointer" @click="showPreviewData(val)">
                  <div v-if="val.profilepic" style="width: 44px" class="profilepic" 
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <img v-lazy="val.profilepic" :key="val.profilepic" class="imgProfile image-skeleton"/>
                    <div class="fs-10 fw-600 noti-count">
                      <el-tooltip :content="getEngagementTooltip(val.house_level)" placement="top">
                        <img :src="getImgHouse(val.house_level)" class="imgProfilehouse"/>
                      </el-tooltip>
                      {{ val.house_level }}
                    </div>
                  </div>
                  <div v-else class="image imgProfile profilepic"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <span class="text-in-image text-in-image-50 flex-mid" style="width: 44px;"> {{
                        $utils("acronymName", {
                          firstName: val.firstname,
                          lastName: val.lastname,
                        })
                      }}</span>
                    <div class="fs-10 fw-600 noti-count">
                      <el-tooltip :content="getEngagementTooltip(val.house_level)" placement="top">
                        <img :src="getImgHouse(val.house_level)" class="imgProfilehouse"/>
                      </el-tooltip>
                      {{ val.house_level }}
                    </div>
                  </div>
                  <div class="flex-column ml-12">
                    <span class="txtName ellipsis fs-13 fw-600 fc-000000"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      {{ val.firstname }} {{ val.lastname }}
                    </span>
                    <span class="txtTeam ellipsis fs-11 fw-500 opa-08 fc-000000"
                    :class="[ blurMode ?  'blurelement': '' ]">{{
                      val.team_name }}</span>
                    <div style="width: 100px; margin-top: 5px;">
                      <el-progress :percentage="val.healthbar" :color="healthBarColor(val.healthbar)"
                        :stroke-width="4" :show-text="false"></el-progress>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="flex-column flex-center">
                <div v-if= "val.talent_value_coin==''" class="bar-contariner flex-center">
                  <div v-for="(value, index) in [1, 2, 3, 4]" :key="index + '_bar_mock_one'"
                    :class="`bar ${value}`"></div>
                </div>
                <div v-else class="bar-contariner flex-center">
                  <div v-for="(value, index) in arrayToRecognition(val.talent_value_coin,'coin')" :key="index + '_bar_mock_one'"
                    :class="`bar ${value}`"></div>
                </div>
                <div class="fs-10 mt-4">Support</div>
              </div>
            </div>
            <div class="fs-9 ml-9 mr-9 mb-9">
              <img class="opa-08" width="8" height="8"src="@/assets/images/people/ic_cross.svg" alt="Cross icon">
            </div>

            <div>
              <div class="flex-column flex-center">
                <div v-if= "val.talent_value_gem==''" class="bar-contariner flex-center">
                  
                    <div v-for="(value, index) in [1, 2, 3, 4]" :key="index + '_bar_mock_one'"
                      :class="`bar ${value}`"></div>
                  </div>
                

                <div v-else class="bar-contariner flex-center">
                  <div v-for="(value, index) in arrayToRecognition(val.talent_value_gem,'gem')" :key="index + '_bar_mock_one'"
                    :class="`bar ${value}`"></div>
                </div>
                <div class="fs-10 mt-4">Performance</div>
              </div>
            </div>
            <div class="section-break ml-24 mr-16"></div>

            <!-- Talent & Network -->
            <div class="flex-center" style="width: 200px;">
              <div class="flex-center mr-6">
                <el-tooltip :content="getTalentTooltip(val.talent)" placement="top" effect="dark">
                  <div :class="`talent-tag cursor-pointer ${talentAndNetworkTagsStyle(val.talent)}`">
                    {{ val.talent=='Latent Potential'?'Starter':val.talent }}
                  </div>
                </el-tooltip>
              </div>

              <div>
                <el-tooltip v-if="val.network_type" :content="getNetworkTooltip(val.network_type)" placement="top" effect="dark">
                  <div :class="`talent-tag cursor-pointer ${talentAndNetworkTagsStyle(val.network_type)}`">
                    {{ val.network_type }}
                  </div>
                </el-tooltip>
              </div>
            </div>
            <div class="section-break ml-24 mr-16"></div>

            <!-- Achievements -->
            <div class="flex-center">
                <div :class="`achievements-contariner ${medals[val.email] < 1|| medals[val.email] == undefined ? 'no-have' : ''
                  }`">
                  <div v-if="medals[val.email] > 0" class="count-icon">
                    {{medals[val.email] }}
                  </div>
                  <img :src="$utils('icons', 'Medals_32')" alt="icons_Medals_32" title="Medals" />
                </div>
                <el-tooltip v-if="truly[val.email] > 0" :content="`In the past 6 months, has received an &quot;Exceeding Expectations&quot; or &quot;Truly Outstanding&quot; Rating from Peer Feedback ${truly[val.email]} ${truly[val.email] === 1 ? 'time' : 'times'}`" placement="top">
                  <div :class="`achievements-contariner ${truly[val.email] == undefined || truly[val.email] < 1
                      ? 'no-have'
                      : ''
                    }`">
                    <div v-if="truly[val.email] > 0" class="count-icon">
                      {{truly[val.email] }}
                    </div>
                    <img class="cursor-pointer" :src="$utils('icons', 'Outstanding_32')" alt="icons_Outstanding_32" title="Exceed Expectations or Truly Outstanding" />
                  </div>
                </el-tooltip>
                <div v-else :class="`achievements-contariner no-have`">
                  <el-tooltip content="In the past 6 months, has not received an Exceeding Expectations or Truly Outstanding Rating from Peer Feedback" placement="top">
                    <img :src="$utils('icons', 'Outstanding_32')" class="cursor-pointer" alt="icons_Outstanding_32" title="Exceed Expectations or Truly Outstanding" />
                  </el-tooltip>
                </div>
            </div>
            <div class="section-break ml-16 mr-16"></div>

            <!-- Alignement -->
            <div class="flex-center">
                <div>
                  <el-tooltip :content="getSkillTooltip(alignement[val.email] ? alignement[val.email].rating_skill : '0.0')" placement="top">
                    <div class="flex-center mt-6 cursor-pointer">
                      <span class="fs-12 fw-700">{{alignement[val.email] ? alignement[val.email].rating_skill : '0.0'}}</span>
                      <img width="12" height="12" :src="getImgStar(alignement[val.email]?alignement[val.email].rating_skill:0)"/>
                    </div>
                  </el-tooltip>
                  <div>
                    <span class="fs-10">Skills</span>
                  </div>
                </div>
                <div class="ml-22">
                  <div class="flex-center">
                    
                      <el-tooltip placement="top" effect="dark">
                        
                        <div slot="content" class="p-5">
                          <div class="fs-13 fw-700 pb-4">Values Alignment</div>
                          <div><strong>Given:</strong> {{ recognition[val.email] ? recognition[val.email].valueAlignmentGiven : 0 }}</div>
                          <div><strong>Received:</strong> {{ recognition[val.email] ? recognition[val.email].valueAlignmentReceived : 0 }}</div>
                          <!-- <div><strong>Combined:</strong> {{ recognition[val.email] ? recognition[val.email].combinedValueAlignment : 0 }}</div> -->
                          <div class="mt-2">This score shows the higher of two values: recognitions given for company values, and recognitions received for embodying them. We display the higher score to highlight an employee's strongest value alignment contribution.</div>
                        </div>
                        
                        <div class="progress-wrapper cursor-pointer">
                          
                        <svg width="32" height="32" viewBox="0 0 32 32">
                        <circle cx="13" cy="13" r="13" fill="none" stroke-width="2" stroke="#E0E0E0"></circle>
                        <circle
                          cx="13" cy="13" r="13" fill="none" :stroke-width="2"
                          :stroke="getStrokeColor(getGreaterValueAlignment(val.email) * 10)" :stroke-dasharray="75.4"
                          :stroke-dashoffset="75.4 - ((getGreaterValueAlignment(val.email) * 10) * 0.754)"
                          transform="rotate(-90 13 13)">
                        </circle>
                      </svg>

                      <div class="score-label">
                        <div class="opa-08 fs-12 fw-700" style="width: 26px;background-color: transparent">
                          {{getGreaterValueAlignment(val.email) === 10 ? '10' : getGreaterValueAlignment(val.email).toFixed(1)}}
                        </div>
                      </div>
                    </div>

                      </el-tooltip>
                      
                  </div>
                  <div style="margin-top: -4px;">
                    <span class="fs-10">Values</span>
                  </div>
                </div>
            </div>
            <div class="section-break ml-16 mr-16"></div>


            <!-- Impact Rating -->
            <div class="flex-center">

              <div :class="`fs-11 fw-700 impact-tag impact-tag-${val.impact_rating < 40
                        ? 'red'
                        : val.impact_rating < 70
                          ? 'yellow'
                          : 'green'
                      }`">
                      <template v-if="!showImpactPercentile">
                        {{ val.impact_rating.toFixed(1) }}
                      </template>
                      <template v-else>
                        {{ calculatePercentile(val.email).toFixed(0) }}%
                      </template>
              </div>

                <div v-if="val.impact_rating > val.impact_rating_lastweek
                  " class="fc-66BB6A flex-center">
                  <img :src="$utils('icons', 'arrow_up_green_24dp')" alt="icons_arrow_up_green_24dp" style="margin-top: 3px;"/>
                  <div class="fs-11 fw-700" style="margin-left: -6px">
                    {{ val.impact_compare.toFixed(1) }}
                  </div>
                </div>
                <div v-else-if="val.impact_rating_lastweek >val.impact_rating
                  " class="fc-F44336 flex-center">
                  <img :src="$utils('icons', 'arrow_down_red_24dp')" alt="icons_arrow_down_red_24dp" style="margin-top: 6px;">
                  <div class="fs-11 fw-700" style="margin-left: -6px;margin-top: 5px;">
                    {{ val.impact_compare.toFixed(1) }}
                  </div>
                </div>
                <div v-else-if="val.impact_rating == val.impact_rating_lastweek
                  ">
                </div>

            </div>


            
          </div>
        </div>
        <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadingPeopleTable">
          <loading-even></loading-even>
        </div>
      </div>
    </div>
    <modal-preview-user v-if="modalPreviewDataStatus" :modalMemberData="modalMemberData" :userDetail="userDetail"
      :showingModal="modalPreviewDataStatus" :passProfileToRelationship="passProfileToRelationship"
      @closed="closedModal"></modal-preview-user>
    <div class="remove-padding-modal">
      <el-dialog :visible.sync="modalViewListExcels" top="12vh" width="480px">
        <div class="recipients-modal-style fc-000000">
          <div class="flex-center">
            <span class="fs-20 fw-700">{{ $t("insights.Excels_at") }}</span>
            <span class="big-tag">{{ viewListExcelsDataSelected.label }}</span>
          </div>
          <div class="mt-24">
            <span class="fs-18 fw-700">{{ viewListExcelsDataSelected.userCount }}
              {{ $t("insights.profiles") }}</span>
          </div>
          <div class="mt-4">
            <span class="fc-626262 fs-14">{{
              $t("insights.were_tagged_by")
            }}</span>
          </div>
        </div>
        <div class="members-recipients thin-scrollbar">
          <div v-for="item in viewListExcelsDataSelected.userList" :key="item.key" class="rowDataStyle">
            <div class="columnDataStyle">
              <div class="flex-center">
                <div class="flex-center" v-if="item.imageProfile">
                  <img v-lazy="item.imageProfile" :key="item.imageProfile" class="image-skeleton image-profile-40" />
                </div>
                <div v-else class="image image-profile-40">
                  <div class="text-in-image text-in-image-40 flex-mid">
                    {{ $utils("acronymName", { fullName: item.fullname }) }}
                  </div>
                </div>
                <div class="flex-column pl-16">
                  <span class="text-name">{{ item.fullname }}</span>
                  <span class="text-email">{{ item.team_name }}</span>
                </div>
                <div class="ml-auto cell flex-mid">
                  {{ item.excelsCount }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "people",
  components: {
    modalPreviewUser: require("@/components/even/modal/user-preview").default,
    loadingEven: require("../even/loading").default,
  },
  created() {
    this.$store.dispatch("people/getStarAndRiskPerform", this.user);
    this.$store.dispatch("report/getOrganization");
    this.$store.dispatch("people/getStarAndRiskDataChart", this.user);
    this.$store.dispatch("team/getTeamsOptions", this.user);
    this.$store.dispatch("people/getAlignement", this.user);
    
    // Don't rely on the watch - directly fetch all company data
    this.fetchAllCompanyRatings();
  },
  props: {
    tabActive: String,
  },
  watch: {
    // optionsTeam() {
    //   if(this.optionsTeam.length > 0){
    //     this.selectTeam = this.user.user_type == 'leadership' ? this.user.team : "";
    //   }
    // },
    inputSearch() {
      setTimeout(() => {
        this.$store.dispatch("people/searchMembers", this.checkedTalentType);
      }, 500);
    },
    selectTeam() {
      // this.$store.dispatch("people/getStarAndRiskDataChart", "");
      if (!this.loadingDataChart && !this.loadingDataChartFirstTime && this.optionsTeam.length > 0) {
        this.$store.dispatch("people/searchByTeam", this.checkedTalentType);
      }
    },
    loadingDataChartFirstTime() {
      if (!this.loadingDataChartFirstTime) {
        this.$store.dispatch("people/searchByTeam", this.checkedTalentType);
      }
    },
    RiskAndStarChart() {
      if (!this.loadingDataChart && !this.loadingDataChartFirstTime) {
        if (this.my_bar_chart) this.my_bar_chart.destroy();
        this.randerBarChart();
        if (this.my_line_chart) this.my_line_chart.destroy();
        this.randerLineChart();
      }
    },
    tabActive(val) {
      if (val == "people") {
        if (this.my_bar_chart) {
          this.my_bar_chart.destroy();
        }
        this.randerBarChart();
        if (this.my_line_chart) {
          this.my_line_chart.destroy();
        }
        this.randerLineChart();
      } else {
        if (this.my_bar_chart) {
          this.my_bar_chart.destroy();
        }
        if (this.my_line_chart) {
          this.my_line_chart.destroy();
        }
      }
    },
  },
  computed: {
    inputSearch: {
      get() {
        // this.checkedTalentType = this.talentTypeOptionAllCheck
        return this.$store.getters["people/inputSearch"];
      },
      set(value) {
        this.$store.commit("people/setinputSearch", {
          keyword: value,
          userstatus: this.type,
        });
      },
    },
    selectTeam: {
      get() {
        if (this.optionsTeam.length > 0) {
          return this.$store.getters["people/selectTeam"];
        }
        // this.checkedTalentType = this.talentTypeOptionAllCheck

      },
      set(value) {
        if (this.optionsTeam.length > 0) {
          this.$store.commit("people/setTeamId", { keyword: value });
        }
      },
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    // peoplerisk() {
    //   return this.$store.getters["people/peoplerisk"];
    // },
    starperform() {
      if (
        this.$store.getters["people/starperform"].length > 0 &&
        this.loadingPeopleTable
      ) {
        this.loadingPeopleTable = false;
      }
      return this.$store.getters["people/starperform"];
    },
    optionsTeam() {
      const optionsTeam = this.$store.getters["team/teamsall"];
      if (this.user.user_type == 'leadership') {
        this.$store.commit("people/setTeamId", { keyword: this.user.team });
      } else {
        this.$store.commit("people/setTeamId", {
          keyword: `All Teams (${optionsTeam.length})`,
        });
      }
      return optionsTeam;
    },
    talentTypeOption() {
      return this.$store.getters["people/talentTypeOption"];
    },
    modalMemberData() {
      return this.$store.getters["people/modalMemberData"];
    },
    membersall() {
      return this.$store.getters["people/membersall"];
    },
    passProfileToRelationship() {
      let passProfile = {
        firstname: this.userDetail.firstname || "",
        lastname: this.userDetail.lastname || "",
        teamColor: this.userDetail.house_color || "",
        house: this.userDetail.house || "",
        pic: this.userDetail.large_pic || false,
      };
      return passProfile;
    },
    RiskAndStarChart() {
      return this.$store.getters["people/RiskAndStarChart"];
    },
    talentChartData() {
      return this.$store.getters["people/talentChartData"];
    },
    networkChartData() {
      return this.$store.getters["people/networkChartData"];
    },
    // powerChartData() {
    //   return this.$store.getters["people/powerChartData"];
    // },
    // excelsAtDataChart() {
    //   return this.$store.getters["people/excelsAtDataChart"];
    // },
    viewListExcelsData() {
      return this.$store.getters["people/viewListExcelsData"];
    },
    labelDate() {
      return this.$store.getters["people/labelDate"];
    },
    loadingDataChart() {
      return this.$store.getters["people/loadingDataChart"];
    },
    loadingDataChartFirstTime() {
      return this.$store.getters["people/loadingDataChartFirstTime"];
    },
    allDataImpactTooltip() {
      return this.$store.getters["people/allDataImpactTooltip"];
    },
    alignement() {
      return this.$store.getters["people/alignement"];
    },
    recognition() {
      return this.$store.getters["people/recognition"];
    },
    truly() {
      return this.$store.getters["people/truly"];
    },
    medals() {
      return this.$store.getters["people/medals"];
    },
    isAllTeamsSelected() {
      return this.selectTeam && this.selectTeam.includes('All Teams');
    },
    percentileScopeText() {
      // No need for scoped text in All Teams view
      return this.isAllTeamsSelected 
        ? this.$t("insights.Entire_Company")
        : (this.percentileScope === "filtered" 
            ? this.$t("insights.Current_Filtered_List") 
            : this.$t("insights.Entire_Company"));
    },
    percentileScopeShortText() {
      // No need for scoped text in All Teams view
      return this.isAllTeamsSelected 
        ? this.$t("insights.Global")
        : (this.percentileScope === "filtered" 
            ? this.$t("insights.Scoped") 
            : this.$t("insights.Global"));
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  data() {
    return {
      options: [
        {
          value: "All Teams",
          label: "All Teams",
        },
        {
          value: "Teams1",
          label: "Teams1",
        },
      ],
      type: "all",
      checkedTalentType: [],
      disp_talentType: "All_Types",
      arrDataCheck: [],
      modalPreviewDataStatus: false,
      loadingPeopleTable: false,
      userDetail: {},
      // timeShowingData: "By Week",
      PowerSkillShowingData: "Talent Type",
      modalViewListExcels: false,
      viewListExcelsDataSelected: {},
      my_line_chart: null,
      my_bar_chart: null,
      showImpactPercentile: false,
      percentileScope: "filtered", // 'filtered' or 'global'
      allCompanyRatings: [], // Store entire company ratings for global percentile
    };
  },
  mounted() {
    if (this.optionsTeam.length > 0 && this.selectTeam == '') {
      this.selectTeam = this.user.user_type == 'leadership' ? this.user.team : "";
    }
    this.loadingPeopleTable = true;
  },
  methods: {
    filterRisk(type) {
      if (type == "all") {
        document.getElementById("filterRisk").innerHTML = "All";
      } else if (type == "low") {
        document.getElementById("filterRisk").innerHTML = "Low Risk";
      } else if (type == "med") {
        document.getElementById("filterRisk").innerHTML = "Med Risk";
      } else if (type == "high") {
        document.getElementById("filterRisk").innerHTML = "High Risk";
      }
      this.$store.dispatch("people/filterRisk", type);
    },
    sortBy(type) {
      if (type == "highest_star") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Highest_Star_Count"
        );
      } else if (type == "lowest_star") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Lowest_Star_Count"
        );
      } else if (type == "highest_risk") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Highest_Risk_Level"
        );
      } else if (type == "lowest_risk") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Lowest_Risk_Level"
        );
      } else if (type == "highest_impact") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Highest_Impact_Rating"
        );
      } else if (type == "lowest_impact") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Lowest_Impact_Rating"
        );
      }
      this.type = type;
      this.$store.dispatch("people/sortBy", {
        type: type,
        checked: this.checkedTalentType,
      });
    },
    getImgPeopleUrl(pic) {
      var replacePic = pic.replace(/ /g, "_");
      var images = require.context(
        "../../assets/images/people/",
        false,
        /\.png$/
      );
      return images("./" + replacePic + "@2x.png");
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getImgStar(value){
      if(Number(value)<1.75){
        return require("@/assets/images/people/star_and_health_indicators/power_star_red@2x.png");
      }else if(Number(value)>=1.75&&Number(value)<3.5){
        return require("@/assets/images/people/star_and_health_indicators/power_star_yellow@2x.png");
      }else if(Number(value)>=3.5){
        return require("@/assets/images/people/star_and_health_indicators/power_star_green@2x.png");
      }
     
    },
    getImgHouse(name){
   
      return require("@/assets/images/people/badges_level/" + name + ".png");

    },
    handleSelectAll() {
      if (this.checkedTalentType.length !== this.talentTypeOption.length) {
        let checked = [];
        for (const i in this.talentTypeOption) {
          checked.push(this.talentTypeOption[i].type);
        }
        this.checkedTalentType = checked;
      }
    },
    dropdownTalentTypeClick() {
      if (this.arrDataCheck.length == 0) {
        let checked = [];
        for (const i in this.talentTypeOption) {
          checked.push(this.talentTypeOption[i].type);
        }
        this.checkedTalentType = checked;
        this.arrDataCheck = checked;
      }
    },
    cancelTalentType() {
      this.checkedTalentType = this.arrDataCheck;
      this.$refs.dropdownMenu.visible = false;
    },
    saveTalentType() {
      if (this.checkedTalentType.length > 0) {
        if (this.checkedTalentType.length == this.talentTypeOption.length) {
          this.disp_talentType = "All_Types";
        } else if (this.checkedTalentType.length == 1) {
          if (
            this.checkedTalentType[0] == "High Network" ||
            this.checkedTalentType[0] == "High Inner" ||
            this.checkedTalentType[0] == "High Outer" ||
            this.checkedTalentType[0] == "Low Network" ||
            this.checkedTalentType[0] == "Medium Network" ||
            this.checkedTalentType[0] == "Super Network" ||
            this.checkedTalentType[0] == "Medium Inner" ||
            this.checkedTalentType[0] == "Medium Outer" ||
            this.checkedTalentType[0] == "Super Inner" ||
            this.checkedTalentType[0] == "Super Outer"
          ) {
            this.disp_talentType = this.checkedTalentType[0].replace(/ /g, "_");
          } else {
            this.disp_talentType = this.checkedTalentType[0];
          }
        } else {
          this.disp_talentType = "Multiple_Selection";
        }
        this.arrDataCheck = this.checkedTalentType;
        this.$store.dispatch("people/searchByTalent", this.checkedTalentType);
        this.$refs.dropdownMenu.visible = false;
      }
    },
    showPreviewData(row, column, event) {
      const item = row;
      this.userDetail = {};
      if (item.introduce) this.userDetail.introduce = item.introduce;
      if (item.culture_add_percentile) this.userDetail.culture_add_percentile = item.culture_add_percentile
      this.userDetail.large_pic = item.large_pic;
      this.userDetail.firstname = item.firstname;
      this.userDetail.lastname = item.lastname;
      this.userDetail.email = item.email;
      this.userDetail.dispteam = item.team_name;
      let colorCode = item.team_color ? item.team_color.replace(/#/g, "") : "";
      this.userDetail.team_color = colorCode;
      this.userDetail.team = item.team;
      this.userDetail.boss = item.boss;
      this.userDetail.tmp_boss = item.boss;
      this.userDetail.boss_pic = item.boss_pic;
      this.userDetail.dispboss = item.boss_name;
      this.userDetail.boss_firstname = item.boss_firstname;
      this.userDetail.boss_lastname = item.boss_lastname;
      this.userDetail.language = item.language;
      this.userDetail.user_type = item.user_type;
      this.userDetail.status = item.status;
      this.userDetail.to_now = item.to_now;
      this.userDetail.streak_count = item.streak_count ? item.streak_count : 0;
      this.userDetail.super_feedback_count = item.super_feedback_count
        ? item.super_feedback_count
        : 0;
      this.userDetail.medal = item.medal ? item.medal : [];
      this.userDetail.coin = item.coin;
      this.userDetail.gem = item.gem;
      this.userDetail.house = item.house;
      this.userDetail.joined = item.joined ? item.joined : "";
      this.userDetail.joined_tooltips =
        item.joined_tooltips && item.joined_tooltips.length > 0
          ? item.joined_tooltips[0]
          : [];
      if (item.order_join) {
        let joinTotal = Object.keys(this.membersall).filter(
          (k) => this.membersall[k].order_join
        ).length;
        this.userDetail.joined_tooltips["percent"] = (
          ((joinTotal - item.order_join) / joinTotal) *
          100
        ).toFixed();
      }
      this.$store.dispatch("newmember/getDataHerepoint", item.email);
      this.$store.dispatch("people/getModalMemberData", item);
      this.modalPreviewDataStatus = true;
    },
    closedModal() {
      this.$store.commit("people/setModalMemberData", []);
      this.modalPreviewDataStatus = !this.modalPreviewDataStatus;
    },
    titleInfo(creatElement, { column, $index }) {
      return <div class="fs-12">{this.$t("insights.Name_Team_and")}</div>;
    },
    titleTalentTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <div class="fs-12">{this.$t("insights.Talent_Type")}</div>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5 ml-auto">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Talent_Type")}
              </div>
              <div>{this.$t("insights.Talent_is_classified")}</div>
              <div>
                {this.$t("insights.coins_and_gems")}{" "}
                <span class="italic">{this.$t("insights.Network")}</span>
              </div>
              <div>
                <span class="italic">{this.$t("insights.Effectiveness")}</span>.{" "}
                {this.$t("insights.Gems_are_a_measure")}{" "}
                <span class="italic">
                  {this.$t("insights.Individual_Performance")}
                </span>
                .
              </div>
              <div>
                1. <span class="fw-700">{this.$t("insights.Low")}</span>:{" "}
                {this.$t("insights.Low_frequency")}
              </div>
              <div>
                2. <span class="fw-700">{this.$t("insights.Uptake")}</span>:{" "}
                {this.$t("insights.A_recent_increase_in")}
              </div>
              <div>
                3. <span class="fw-700">{this.$t("insights.High")}</span>:{" "}
                {this.$t("insights.High_frequency")}
              </div>
              <div>
                4. <span class="fw-700">{this.$t("insights.Super")}</span>:{" "}
                {this.$t("insights.High_frequency_and_high")}
              </div>
              <div class="read-more">
                <a
                  href="https://www.notion.so/happilyai/Insights-Talent-Type-8dded941ece343968466954e585f4d7d"
                  target="_blank"
                >
                  {this.$t("insights.Read_more_here")}
                </a>
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    titleNetworkTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <span class="fs-12">{this.$t("insights.Network_Type")}</span>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Network_Type")}
              </div>
              <div>{this.$t("insights.Talent_is_classified_by")}</div>
              <div>{this.$t("insights.connections_as_determined")}</div>
              <div>{this.$t("insights.recognition_and_peer")}:</div>
              <div>
                1. <span class="fw-700">{this.$t("insights.Low_Network")}</span>
                : {this.$t("insights.Low_inner_and_outer")}
              </div>
              <div>
                2. <span class="fw-700">{this.$t("insights.High_Inner")}</span>:{" "}
                {this.$t("insights.High_Inner_but_low")}
              </div>
              <div>
                3. <span class="fw-700">{this.$t("insights.High_Outer")}</span>:{" "}
                {this.$t("insights.Low_inner_but_high")}
              </div>
              <div>...</div>
              <div>
                9.{" "}
                <span class="fw-700">{this.$t("insights.High_Network")}</span>:{" "}
                {this.$t("insights.High_Network")}
              </div>
              <div class="read-more">
                <a
                  href="https://www.notion.so/happilyai/Insights-Network-Type-dfde58f252fa4079aca2aed3a4ba7e4e"
                  target="_blank"
                >
                  {this.$t("insights.Read_more_here")}
                </a>
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    titleAchievementsTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <div class="fs-12">{this.$t("insights.Achievements")}</div>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5" style="width: 350px">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Achievements")}
              </div>
              <div>{this.$t("insights.Highlighting_key_accomplishments")}:</div>
              <div>
                -{" "}
                <span class="fw-700">
                  {this.$t("insights.Engagement_Group")}
                </span>
                : {this.$t("insights.Highly_Moderately_Somewhat_Under")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.Medals")}</span>:{" "}
                {this.$t("insights.Recognized_with_a_Leadership")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">
                  {this.$t("insights.Truly_Outstanding")}
                </span>
                : {this.$t("insights.Recognized_as_Truly_Outstanding")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">{this.$t("insights.Star_Performer")}</span>
                : {this.$t("insights.A_star_is_earned")}
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    titleImpactRatingTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <div class="fs-12">{this.$t("insights.Impact_Rating")}</div>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5" style="width: 350px">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Impact_Rating")}
              </div>
              <div>{this.$t("insights.A_score_that_represents")}:</div>
              <div>
                - <span class="fw-700">{this.$t("insights.Talent_Type")}</span>:{" "}
                {this.$t("insights.Based_on_manager_and")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.Network_Type")}</span>
                : {this.$t("insights.Based_on_connections_created")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">
                  {this.$t("insights.Engagement_Group")}
                </span>
                : {this.$t("insights.Based_on_the_quality_and")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.Medals")}</span>:{" "}
                {this.$t("insights.Medals_received_in_the")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">
                  {this.$t("insights.Truly_Outstanding")}
                </span>
                : {this.$t("insights.Truly_Outstanding_ratings")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">{this.$t("insights.Star_Performer")}</span>
                : {this.$t("insights.Number_of_weeks_qualified")}
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    titleRiskLevelTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <div class="fs-12">{this.$t("insights.Risk_Level")}</div>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5" style="width: 350px;">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Risk_Level")}
              </div>
              <div>{this.$t("insights.Talent_that_are_retention")}</div>
              <div>{this.$t("insights.of_Not_Great_and")}</div>
              <div>{this.$t("insights.you_feeling_today")}</div>
              <div>
                - <span class="fw-700">{this.$t("insights.Low")}</span>:{" "}
                {this.$t("insights.Twice_last_week")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.Medium")}</span>:{" "}
                {this.$t("insights.More_than_twice")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.High")}</span>:{" "}
                {this.$t("insights.More_than_twice_last_and")}
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    randerBarChart() {
      let chart = this.$refs.riskAndStartBarchart;
      if (chart) {
        var ctx = chart.getContext("2d");
        const impact_rating_length = this.RiskAndStarChart.impact_rating || [];
        const impact_rating = [];
        if (impact_rating_length.length > 0) {
          for (let i = 0; i < impact_rating_length.length; i++) {
            impact_rating.push(
              (this.RiskAndStarChart.impact_rating[i] / 10).toFixed(2)
            );
          }
        }
        const data = {
          labels: this.labelDate,
          datasets: [
            {
              data: this.RiskAndStarChart.highrisk,
              backgroundColor: "#900505",
              label: "High",
              borderWidth: 0,
              stack: "combined",
              type: "bar",
              stack: "Stack 0",
              lowrisk: this.RiskAndStarChart.lowrisk,
              medrisk: this.RiskAndStarChart.medrisk,
              highrisk: this.RiskAndStarChart.highrisk,
              impact_rating: impact_rating,
              datalabels: {
                display: false,
              },
            },
            {
              data: this.RiskAndStarChart.medrisk,
              backgroundColor: "#C41919",
              label: "Medium",
              borderWidth: 0,
              stack: "combined",
              type: "bar",
              stack: "Stack 0",
              lowrisk: this.RiskAndStarChart.lowrisk,
              medrisk: this.RiskAndStarChart.medrisk,
              highrisk: this.RiskAndStarChart.highrisk,
              impact_rating: impact_rating,
              datalabels: {
                display: false,
              },
            },
            {
              data: this.RiskAndStarChart.lowrisk,
              sumData: this.RiskAndStarChart.sumrisk,
              backgroundColor: "#E21A1A",
              label: "Low",
              borderWidth: 0,
              stack: "combined",
              type: "bar",
              stack: "Stack 0",
              lowrisk: this.RiskAndStarChart.lowrisk,
              medrisk: this.RiskAndStarChart.medrisk,
              highrisk: this.RiskAndStarChart.highrisk,
              impact_rating: impact_rating,
              datalabels: {
                color: "#F44336",
                anchor: "end",
                align: "end",
                clamp: true,
                offset: 0,
              },
            },
            {
              stack: "combined",
              data: impact_rating,
              backgroundColor: "#35d077",
              borderColor: "#35d077",
              pointHoverRadius: 0,
              pointRadius: 0,
              borderWidth: 0,
              lineTension: 0,
              pointColor: "#35d077",
              strokeColor: "#35d077",
              label: "Impact Rating",
              hover: false,
              lowrisk: this.RiskAndStarChart.lowrisk,
              medrisk: this.RiskAndStarChart.medrisk,
              highrisk: this.RiskAndStarChart.highrisk,
              impact_rating: impact_rating,
              datalabels: {
                display: false,
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        const getOrCreateTooltip = (chart) => {
          let tooltipEl = chart.canvas.parentNode.querySelector("div");

          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.style.background = "rgba(0, 0, 0, 0.7)";
            tooltipEl.style.borderRadius = "3px";
            tooltipEl.style.color = "white";
            tooltipEl.style.opacity = 1;
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.transform = "translate(-50%, 0)";
            tooltipEl.style.transition = "all .1s ease";

            const table = document.createElement("table");
            table.style.margin = "0px";

            tooltipEl.appendChild(table);
            chart.canvas.parentNode.appendChild(tooltipEl);
          }

          return tooltipEl;
        };

        const addCommasInNumber = (value) => {
          let num, oneDigit, str;
          if (value === undefined || value === null) {
            return "0";
          } else if (typeof value === "number") {
            num = value.toFixed(2);
          } else {
            num = value;
          }

          str = num.toString().split(".");
          if (str[0].length >= 4) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
          }
          if (str[1]) {
            oneDigit = str[1].split("");
            if (str[1] === "00") {
              str = str[0];
            } else if (oneDigit[1] === "0") {
              str[1] = oneDigit[0];
              str = str.join(".");
            } else {
              str = str.join(".");
            }
          } else {
            str = str[0];
          }
          return str;
        };

        const externalTooltipHandler = (context) => {
          const { chart, tooltip } = context;
          const tooltipEl = getOrCreateTooltip(chart);

          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          if (tooltip.body) {
            const bodyLines = tooltip.body.map((b) => b.lines);
            const tableHead = document.createElement("thead");
            const tableBody = document.createElement("tbody");
            bodyLines.forEach((body, i) => {
              const dataPoints = tooltip.dataPoints[i];
              const span = `<div class="container-tooltip" style="z-index: 99">
                  <div style="position: relative; width: 140px;">
                    <div style="font-size: 11px; font-weight: 700;">
                      ${dataPoints.label}
                    </div>
                    <div style="display: flex; align-items: center; font-size: 11px; margin-top: 2px;">
                      <div style="width: 14px; height: 12px; background-color: #e21a1a; margin-right: 6px;"></div>
                      <div>Low: ${addCommasInNumber(
                dataPoints.dataset.lowrisk[dataPoints.dataIndex]
              )}</div>
                    </div>
                    <div style="display: flex; align-items: center; font-size: 11px; margin-top: 2px;">
                      <div style="width: 14px; height: 12px; background-color: #c41919; margin-right: 6px;"></div>
                      <div>Medium: ${addCommasInNumber(
                dataPoints.dataset.medrisk[dataPoints.dataIndex]
              )}</div>
                    </div>
                    <div style="display: flex; align-items: center; font-size: 11px; margin-top: 2px;">
                      <div style="width: 14px; height: 12px; background-color: #900505; margin-right: 6px;"></div>
                      <div>High: ${addCommasInNumber(
                dataPoints.dataset.highrisk[dataPoints.dataIndex]
              )}</div>
                    </div>
                    <div style="display: flex; align-items: center; font-size: 11px; margin-top: 2px;">
                      <div style="width: 14px; height: 2px; background-color: #35d077; margin-right: 6px;"></div>
                      <div>Impact Rating: ${(
                  dataPoints.dataset.impact_rating[dataPoints.dataIndex] *
                  10
                ).toFixed(1)}</div>
                    </div>
                    <div style="position: absolute; bottom: -17.5px; left: 48%;">
                      <div style="border: 5px solid #000; border-color: #000000ae transparent transparent; width: 0px; height: 0px;"></div>
                    </div>
                  </div>
                </div>`;
              tableBody.innerHTML = span;
            });

            const tableRoot = tooltipEl.querySelector("table");

            while (tableRoot.firstChild) {
              tableRoot.firstChild.remove();
            }

            tableRoot.appendChild(tableHead);
            tableRoot.appendChild(tableBody);
          }

          const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltip.caretX + "px";
          tooltipEl.style.top = positionY + tooltip.caretY + -56 + "px";
          tooltipEl.style.font = tooltip.options.bodyFont.string;
          tooltipEl.style.padding =
            tooltip.options.padding + "px " + tooltip.options.padding + "px";
        };
        options.layout = {
          padding: {
            left: 0,
            right: 33,
          },
        };
        options.datasets = {
          bar: {
            categoryPercentage: 0.4, // Adjust this value (0-1)
            borderRadius: 4,
          },
        };
        options.scales = {
          y: {
            stacked: true,
            ticks: {
              stepSize: 100,
              display: true,
            },
            grid: {
              display: false,
            },
          },
          x: {
            grid: {
              display: false,
            },
          },
        };
        options.interaction = {
          intersect: false,
          mode: "nearest",
          axis: "xy",
        },
          options.plugins.tooltip = {
            enabled: false,
            position: "average",
            intersect: false,
            external: externalTooltipHandler,
          };
        options.plugins.datalabels = {
          formatter: function (value, context) {
            return context.dataset.sumData[context.dataIndex];
          },
          font: {
            weight: "bold",
            size: 10,
          },
          color: "#E21A1A",
        };
        setTimeout(() => {
          this.my_bar_chart = new Chart(ctx, {
            type: "line",
            data: data,
            options: options,
            plugins: [ChartDataLabels],
          });
        }, 500);
      }
    },
    randerLineChart() {
      let chart = this.$refs.impactLinechart;
      if (chart) {
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.layout = {
          padding: {
            left: 29,
            right: 0,
          },
        };
        options.datasets = {
          bar: {
            categoryPercentage: 0.6,
            borderRadius: 4,
          },
        };
        options.scales = {
          y: {
            stacked: true,
            max: 100,
            min: 0,
            position: "right",
            ticks: {
              stepSize: 100,
              display: true,
            },
            grid: {
              display: false,
            },
          },
          x: {
            grid: {
              display: false,
            },
          },
        };
        options.animation = {
          duration: 1200,
          easing: "easeInOutExpo",
          colors: {
            duration: 300,
            delay: 900,
            backgroundColor: "transparent",
            from: "transparent",
          },
          x: {
            duration: 10,
            from: 3000,
          },
          y: {
            duration: 1200,
            from: 3000,
          },
        };
        var ctx = chart.getContext("2d");
        let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
        gradientFill.addColorStop(0, "#35D077cc");
        gradientFill.addColorStop(1, "#35D07700");
        const data = {
          datasets: [
            {
              data: this.RiskAndStarChart.impact_rating,
              backgroundColor: gradientFill,
              borderWidth: 1,
              borderColor: "#35D077",
              pointHoverRadius: 0,
              pointRadius: 0,
              lineTension: 0,
              fill: true,
              hover: false,
              label: "Star performers",
              type: "line",
            },
          ],
          labels: ["", "", "", "", "", "", "", ""],
        };
        this.my_line_chart = new Chart(ctx, {
          type: "line",
          data: data,
          options: options,
        });
      }
    },
    setBarWidth(value, max) {
      let percentage = (value / max) * 100;
      return (234 / 100) * percentage;
    },
    setBarExcelsWidth(percentage) {
      return (80 * percentage) / 100 || "0";
    },
    handlePowerPick(command) {
      this.PowerSkillShowingData = command;
    },
    healthBarColor(value) {
      if (value < 25) {
        return "#B40303";
      } else if (value < 50) {
        return "#F44336";
      } else if (value < 75) {
        return "#FBC02D";
      } else {
        return "#66BB6A";
      }
    },
    talentAndNetworkTagsStyle(value) {
      if (value == "Low Network" || value == "Latent Potential") {
        return "tag-red";
      } else if (
        value == "Medium Inner" ||
        value == "Medium Outer" ||
        value == "Medium Network" ||
        value == "Up-and-coming" ||
        value == "Contributor" ||
        value == "Community Pillar" ||
        value == "Rising Star" ||
        value == "Crowd Favorite"
      ) {
        return "tag-half-red";
      } else if (
        value == "High Outer" ||
        value == "High Inner" ||
        value == "Untapped Potential" ||
        value == "Engaged Contributor" ||
        value == "Emerging Talent" ||
        value == "Valued Contributor" ||
        value == "Key Player" ||
        value == "High Potential" ||
        value == "Unsung Talent"
      ) {
        return "tag-orange";
      } else if (
        value == "Super Outer" ||
        value == "High Network" ||
        value == "Super Inner" ||
        value == "Activated" ||
        value == "Core Player" ||
        value == "High Performer"
      ) {
        return "tag-half-green";
      } else if (
        value == "Super Outer" ||
        value == "Superstar" ||
        value == "High Performer" ||
        value == "Respected Expert" ||
        value == "Distinguished Talent" ||
        value == "Solid Performer"
      ) {
        return "tag-green";
      }
      return "tag-green";
    },
    viewListClick(id) {
      this.modalViewListExcels = true;
      this.viewListExcelsDataSelected = this.viewListExcelsData[id];
    },
    statusOfImpact(value) {

      switch (value) {
        case "a":
          return `<span class="fc-F22F3C fw-900">LOW </span>`;
        case "b":
          return `<span class="fc-C69312 fw-900">OKAY </span>`;
        case "c":
          return `<span class="fc-27BC6C fw-900">GREAT </span>`;
        case "d":
          return `<span class="fc-27BC6C fw-900">EXCELLENT </span>`;
      }
      return ``;
    },
    toolTipClass(value) {
      switch (value) {
        case "a":
          return "color: #F22F3C;";
        case "b":
          return "color: #C69312;";
        case "c":
          return "color: #27BC6C;";
        case "d":
          return "color: #27BC6C;";
      }
    },
    getStrokeColor(value) {
      if (value >= 80) {
        return "#66BB6A";
      } else if (value >= 51 && value <= 79) {
        return "#FBC02D";
      } else {
        return "#F44336";
      }
    },
    getHealthIndicatorImage(riskLevel) {
      const imageMap = {
        '0': 'recovery@2x.png',
        '1': 'risk_low@2x.png',
        '2': 'risk_med@2x.png',
        '3': 'risk_high@2x.png'
      };
      return imageMap[riskLevel] ? require(`@/assets/images/people/${imageMap[riskLevel]}`) : null;
    },
    arrayToRecognition(value,type) {
      const arr = [];
      let color = "bar-red";
      if(type=='gem'){
        if(value=='100'){
          for (let i = 0; i < 4; i++) {
            if(i>0){
              color = "";
            }
            arr.push(`${color}`);
          }
        }else if(value=='110'){
          color = "bar-yellow";
          for (let i = 0; i < 4; i++) {
            if(i>1){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='120'){
          color = "bar-yellow";
          for (let i = 0; i < 4; i++) {
            if(i>2){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='125'){
          color = "bar-green";
          for (let i = 0; i < 4; i++) {
            if(i>2){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='130'){
          color = "bar-green";
          for (let i = 0; i < 4; i++) {
           
            arr.push(`${color}`);
          }

        }
      }else{
        if(value=='000'){
          for (let i = 0; i < 4; i++) {
            if(i>0){
              color = "";
            }
            arr.push(`${color}`);
          }
        }else if(value=='010'){
          color = "bar-yellow";
          for (let i = 0; i < 4; i++) {
            if(i>1){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='020'){
          color = "bar-yellow";
          for (let i = 0; i < 4; i++) {
            if(i>2){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='030'){
          color = "bar-green";
          for (let i = 0; i < 4; i++) {
           
            arr.push(`${color}`);
          }

        }

      }      
      return arr;
    },
    getTalentTooltip(talent) {
      const tooltips = {
        "Latent Potential": "Shows promise but currently under-recognized by both peers and managers.",
        "Contributor": "Beginning to gain manager recognition while still building peer support.",
        "Crowd Favorite": "Highly regarded by peers for support, but not yet fully recognized by management for performance.",
        "Unsung Talent": "Highly valued and recognized by peers for supportiveness, but not yet recognized by management for performance.",
        "Up-and-coming": "Shows early signs of potential, starting to be noticed by both peers and managers.",
        "Rising Star": "Gaining recognition from both peers and management, with stronger management appreciation.",
        "Emerging Talent": "Popular among peers and beginning to gain management recognition for performance.",
        "High Potential": "Highly regarded by peers for supportiveness, with emerging recognition from management for performance.",
        "Community Pillar": "Highly respected by peers but not yet fully recognized by management for performance.",
        "Engaged Contributor": "Valued by peers and starting to gain management recognition for performance.",
        "Core Player": "Key team member with strong peer support and solid management recognition.",
        "Solid Performer": "Consistently meets expectations with both peer and management recognition.",
        "Valued Contributor": "Recognized by management for performance, gradually building peer network.",
        "Key Player": "Important to the team, with growing recognition from both peers and management.",
        "Respected Expert": "Widely respected by peers and highly valued by management for performance.",
        "Distinguished Talent": "Exemplary in management-recognized contributions, with strong peer support.",
        "Untapped Potential": "Highly recognized by management for performance, but not yet well-known or supported by peers.",
        "Activated": "Strong peer support with increasing management recognition of performance.",
        "High Performer": "Excelling in management's view with strong peer respect.",
        "Superstar": "Exceptional contributor recognized widely by both peers and management."
      };

      return tooltips[talent] || "No description available";
    },
    getSkillTooltip(rating) {
      const skillLevel = parseFloat(rating);
      if (isNaN(skillLevel)) return "Invalid rating";

      if (skillLevel >= 0 && skillLevel < 1) {
        return "Developing Awareness: Responses show a beginning recognition of these power skills. There's great potential for growth as engagement and reflection in these areas continue.";
      } else if (skillLevel >= 1 && skillLevel < 2) {
        return "Building Foundation: Responses demonstrate a basic understanding of these power skills. Continued exploration and practice will strengthen this foundation and expand capabilities.";
      } else if (skillLevel >= 2 && skillLevel < 3) {
        return "Actively Applying: Responses indicate regular use of these power skills. Seeking further opportunities to apply and refine them in various situations will enhance proficiency.";
      } else if (skillLevel >= 3 && skillLevel < 4) {
        return "Skillful Integration: Responses reflect strong proficiency in these areas, showing a nuanced understanding and consistent application of these power skills.";
      } else if (skillLevel >= 4 && skillLevel <= 5) {
        return "Mastery and Leadership: Responses demonstrate exceptional command of these power skills. This level of expertise not only shows mastery but also the potential to inspire others. Consider opportunities for mentoring colleagues.";
      } else {
        return "Rating out of range";
      }
    },
    getGreaterValueAlignment(email) {
      if (this.recognition[email]) {
        const given = this.recognition[email].valueAlignmentGiven || 0;
        const received = this.recognition[email].valueAlignmentReceived || 0;
        return Math.max(given, received);
      }
      return 0;
    },
    getNetworkTooltip(networkType) {
      const tooltips = {
        "Low Network": "Limited connections within the organization. Opportunity to expand professional relationships both within and outside immediate team.",
        "Medium Outer": "Developing connections across different departments or teams. Good at bridging gaps between diverse groups in the organization.",
        "Medium Inner": "Strong connections within immediate team or department. Valued collaborator among close colleagues.",
        "Medium Network": "Balanced mix of connections within and outside immediate team. Demonstrates ability to work effectively across various groups.",
        "High Outer": "Extensive connections beyond immediate team. Excels at cross-departmental collaboration and information sharing.",
        "High Inner": "Deeply embedded within immediate team or department. Key player in fostering team cohesion and shared knowledge.",
        "High Network": "Wide-ranging connections throughout the organization. Adept at leveraging relationships for collaborative problem-solving.",
        "Super Outer": "Exceptional at forming connections across the entire organization. Influential in bridging organizational silos and driving cross-functional initiatives.",
        "Super Inner": "Central figure within immediate team or department. Pivotal in shaping team culture and facilitating internal communication.",
        "Super Network": "Extraordinary connection hub across all levels of the organization. Uniquely positioned to influence organizational culture and drive collaborative innovation."
      };
      return tooltips[networkType] || "Network type information";
    },
    getEngagementTooltip(houseLevel) {
      if (houseLevel.includes('novice')) {
        return "Low engagement health: not actively participating in check-ins, feedback and recognition.";
      } else if (houseLevel.includes('Inte')) {
        return "Medium engagement health: shows some activity in check-ins, feedback, and recognition.";
      } else if (houseLevel.includes('Adv')) {
        return "High engagement health: is actively participating in check-ins, feedback, and recognition.";
      } else if (houseLevel.includes('elite')) {
        return "Very high engagement health: is consistent and actively participating in check-ins, feedback, and recognition.";
      } else {
        return "Engagement level not available.";
      }
    },
    calculatePercentile(email) {
      // If we're viewing All Teams, use global calculation for both modes to ensure consistency
      if (this.isAllTeamsSelected || this.percentileScope === "global") {
        // Use global company-wide list
        return this.calculateGlobalPercentile(email);
      } else {
        // Use filtered list for scoped mode
        return this.calculateScopedPercentile(email);
      }
    },
    handlePercentileScope(scope) {
      console.log('Changing percentile scope:', scope);
      this.percentileScope = scope;
    },
    calculateScopedPercentile(email) {
      // Use current filtered/scoped list
      const ratingsToUse = this.starperform
        .map(person => person.impact_rating)
        .filter(rating => rating !== undefined && rating !== null);
      
      // Find person in current filtered list
      const person = this.starperform.find(p => p.email === email);
      const personRating = person ? person.impact_rating : undefined;
      
      console.log(`Scoped percentile for ${email}: using ${ratingsToUse.length} filtered ratings`);
      
      if (!personRating || ratingsToUse.length === 0) {
        console.log(`No rating found for ${email} in scoped list or empty ratings list`);
        return 0;
      }
      
      // Count how many ratings are less than or equal to this person's rating
      const countLessOrEqual = ratingsToUse.filter(rating => rating <= personRating).length;
      
      // Calculate percentile
      const percentile = (countLessOrEqual / ratingsToUse.length) * 100;
      
      console.log(`Scoped percentile for ${email}: ${percentile.toFixed(1)}%`);
      return percentile;
    },
    calculateGlobalPercentile(email) {
      // Check if we need to refresh global data
      if (this.allCompanyRatings.length === 0) {
        this.fetchAllCompanyRatings();
        return 0; // Will update on next render
      }
      
      // Get all ratings from global data
      const ratingsToUse = this.allCompanyRatings
        .map(person => person.impact_rating)
        .filter(rating => rating !== undefined && rating !== null);
      
      // First try to find person in global list
      let personFromGlobal = this.allCompanyRatings.find(p => p.email === email);
      
      // If not found in global list (shouldn't happen), try current list
      if (!personFromGlobal) {
        personFromGlobal = this.starperform.find(p => p.email === email);
      }
      
      const personRating = personFromGlobal ? personFromGlobal.impact_rating : undefined;
      
      console.log(`Global percentile for ${email}: using ${ratingsToUse.length} global ratings`);
      
      if (!personRating || ratingsToUse.length === 0) {
        console.log(`No rating found for ${email} in global list or empty ratings list`);
        return 0;
      }
      
      // Count how many ratings are less than or equal to this person's rating
      const countLessOrEqual = ratingsToUse.filter(rating => rating <= personRating).length;
      
      // Calculate percentile
      const percentile = (countLessOrEqual / ratingsToUse.length) * 100;
      
      console.log(`Global percentile for ${email}: ${percentile.toFixed(1)}%`);
      return percentile;
    },
    fetchAllCompanyRatings() {
      // Access directly from store or use new API call to get all members
      const allMembers = this.$store.getters["people/membersall"];
      
      if (allMembers && Object.keys(allMembers).length > 0) {
        console.log('Fetched all company members:', Object.keys(allMembers).length);
        
        // Convert to array and ensure we have all required fields
        this.allCompanyRatings = Object.values(allMembers)
          .filter(member => member && typeof member === 'object')
          .map(member => ({
            email: member.email,
            impact_rating: parseFloat(member.impact_rating) || 0
          }))
          .filter(member => member.impact_rating > 0);
          
        console.log('Global ratings data count:', this.allCompanyRatings.length);
      } else {
        // If not available immediately, try again in a second
        setTimeout(() => this.fetchAllCompanyRatings(), 1000);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.selectStyle {
  width: 320px;
}

.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}

.txtOptionStar {
  color: #000000;
  font-size: 14px;
  margin-left: 16px;
  width: 190px;
  display: inline-block;
}

.divTable {
  flex: 1;
  margin-left: -9px;
}

.txtPercent {
  margin-left: 6px;
  font-size: 14px;
}

.txtPercent.green {
  color: #27bc6c;
}

.txtPercent.red {
  color: #f44336;
}

.divHeadCurcleRisk {
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  z-index: 10;
}

.divHeadCurcleRisk.red {
  background-color: #b40303;
}

.divHeadCurcleRisk.grey {
  background-color: #939393;
}

.divDetailCurcleRisk {
  width: 72px;
  height: 24px;
  text-align: center;
  border-radius: 20px;
  z-index: 5;
}

.divDetailCurcleRisk.red {
  background-color: #e21a1a;
}

.divDetailCurcleRisk.grey {
  background-color: #bcbcbc;
}

.txtHeadRisk {
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
}

.txtDetailRisk {
  margin-left: 15px;
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  padding-top: 2px;
}
.txtDetailRiskRecovery {
  font-size: 12px;
  font-weight: 700;
  color: #1AC362;
  width: 70px;
  height: 25px;
  padding: 5px 8px 5px 8px;
  
}
.txtStar {
  margin-top: 5px;
  font-size: 20px;
}

.txtStar.risk {
  color: #7e7e7e;
}

.txtStar.perform {
  color: #4d4d4d;
}

.dropdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-left: 24px;
  padding-right: 16px;
  margin-bottom: 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.dropdownFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  padding-right: 16px;
  background: #f8f8f8;
  border-top: 1px solid #e8e8e8;
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}

.dropdownHeaderTextStyle {
  font-size: 13px;
  font-weight: 700;
}

.el-button--text.dropdownHeaderTextStyle {
  color: #32c2d5;
}

.el-button--text.dropdownHeaderTextStyle:hover {
  color: #249fb0;
}

.el-button--text.dropdownHeaderTextStyle:active {
  color: #32c2d5;
}

.el-button--save {
  padding: 4px 16px;
  height: 24px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
}

.el-button--save:hover,
.el-button--save:focus {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 0.7;
}

.el-button--save:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}

.el-button--cancel {
  padding: 4px 16px;
  height: 24px;
  font-size: 13px;
  font-weight: 700;
  color: #747474;
  background-color: #e0e0e0;
  border-color: #e0e0e0;
}

.el-button--cancel:hover,
.el-button--cancel:focus {
  color: #747474;
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  opacity: 0.7;
}

.el-button--cancel:active {
  color: #747474;
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  opacity: 1;
}

.dispTalentTypeStyle {
  height: 24px;
  margin-right: 12px;
}

.tooltipStyle {
  width: 375px;
}

.buttom-detail-image {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  transition: 0.3s;
  opacity: 0;
  background: #fafafa;
}

.read-more {
  margin-top: 15px;

  >a {
    font-size: 12px;
    color: #32c2d5;
    text-decoration: none;
  }
}

.split-risk-power {
  display: grid;
  grid-template-columns: 600px auto;
  margin: 24px 0 32px;

  .power-container {
    margin-left: 16px;
    background-color: rgba(#000000, 0.03);
    padding: 24px 12px 10px 24px;
    border-radius: 24px;
  }

  .risk-container {
    background-color: rgba(#000000, 0.03);
    padding: 24px 24px 14px;
    border-radius: 24px;

    .risk-title {
      width: 12px;
      height: 12px;
    }

    .risk-title.one {
      background-color: #e21a1a;
    }

    .risk-title.two {
      background-color: #c41919;
    }

    .risk-title.three {
      background-color: #900505;
    }

    .risk-title.line {
      width: 20px;
      height: 2px;
      border-radius: 2px;
      background-color: #35d077;
    }
  }

  .power-tabs {
    width: calc(234px - 32px);
    height: 24px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    padding: 4px 16px;
    margin-top: 4px;
    border-radius: 3px;
    letter-spacing: 1.12px;
    position: relative;
    background-color: rgba($color: #000000, $alpha: 0.14);

    .color-bar {
      position: absolute;
      border-radius: 3px;
      left: 0;
      height: 32px;
    }

    .color-bar.ic_empathy {
      background-color: #6000da;
    }

    .color-bar.ic_selfawareness {
      background-color: #f77511;
    }

    .color-bar.ic_criticalthinking {
      background-color: #ff2b19;
    }

    .color-bar.ic_leadership {
      background-color: #00aa1a;
    }

    .color-bar.ic_initiative {
      background-color: #8ce100;
    }

    .color-bar.ic_optimism {
      background-color: #e2ec00;
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #000000;
    font-size: 14px;
    font-weight: 700;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
}

.network-container {
  .text-left-table {
    width: 30px;
    padding-top: 90px;

    .text {
      position: absolute;
      width: 100px;
      text-align: center;
      font-size: 11px;
      margin-left: -36px;
      color: rgba(#000000, 0.8);
      transform: rotate(-90deg);
    }
  }

  .grid-table {
    width: 184px;
    display: grid;
    grid-template-columns: 45px 45px 45px 45px;
    border: 1px solid rgba(#000000, 0.2);
    border-width: 0 0 2px 2px;
    padding: 0 0 8px 12px;

    .cell {
      margin: auto;
      width: 42px;
      padding-top: 2px;
      height: 32px;
      margin: 0px 3px 3px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      position: relative;
    }

    .cell.c-FBC02D {
      background: #fbc02d;
    }

    .cell.c-C2E337 {
      background: #c2e337;
    }

    .cell.c-66BB6A {
      background: #66bb6a;
    }

    .cell.c-EF8D3A {
      background: #ef8d3a;
    }

    .cell.c-F44336 {
      background: #f44336;
    }

    .min-of-cell-2 {
      position: absolute;
      bottom: -6px;
      width: 42px;
      z-index: 99;
    }
  }
}

.excels-card {
  max-width: 242px;
  margin-bottom: 6px;

  .percent-tag {
    width: 80px;
    border-radius: 10px;
    height: 10px;

    .percent {
      border-radius: 10px;
      height: 10px;
      background-color: #6c30cc;
    }
  }

  .expend-user {
    background-color: rgba(#6c30cc, 0.08);
    box-shadow: 0px 3px 6px #00000005;
    border-radius: 4px;
    padding: 8px 12px 8px 16px;
    margin-top: 6px;
    user-select: none;

    .user-cell {
      position: relative;
      margin-right: 12px;

      .count-excels {
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translate(7px, -50%);
        padding: 2px 4px 0px;
        background-color: #006772;
        color: #fff;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 700;
      }
    }
  }
}

.recipients-modal-style {
  padding-top: 40px;
  padding-left: 40px;
  padding-bottom: 16px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 6px #00000014;

  .big-tag {
    padding: 7px 16px;
    font-weight: 700;
    font-weight: 16px;
    margin-left: 12px;
    color: #fff;
    border-radius: 4px;
    background-color: #0097a7;
  }
}

.members-recipients {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 40px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 55vh;
}

.rowDataStyle {
  margin-bottom: 16px;

  .cell {
    height: 28px;
    width: 31px;
    padding-top: 3px;
    background-color: #006772;
    border-radius: 4px;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
  }
}

.talent-tag {
  width: 100%;
  padding: 4px 8px 4px 8px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
}

.tag-red {
  background-color: #F4433620;
  color: #7E120A;
}

//  .tag-half-red{
//   background-color: rgba(#ef8d3a, 0.3);
//   color: #6f3f16;
// }

.tag-orange, .tag-half-red {
  background-color: #FBC02D20;
  color: #7E6016;
}

.tag-green, .tag-half-green {
  background-color: #66BB6A20;
  color: #008406;
}

// .tag-green {
//   background-color: rgba(#66bb6a, 0.3);
//   color: #124314;
// }

.impact-tag {
  line-height: 20px;
}

.achievements-contariner {
  width: 32px;
  margin-right: 6px;
  position: relative;

  .count-icon {
    position: absolute;
    top: -4px;
    right: -4px;
    height: 16px;
    min-width: 16px;
    padding: 0 1px;
    text-align: center;
    border-radius: 32px;
    background-color: #343434;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;
  }
}

.achievements-contariner.no-have {
  opacity: 0.2;

  >img {
    filter: grayscale(100%);
  }
}

.engagement-no-data {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  margin-bottom: 7px;
  background-color: #ebebeb;
  font-weight: 700;
  font-size: 9px;
  line-height: 10px;
  color: #fff;
  text-align: center;
}

.box-card-table {
  position: relative; // Add this
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #0000001F;
  border-radius: 6px;
  opacity: 1;
  min-height: 64px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    cursor: pointer;
    
    // Prevent scaling of health indicator
    > .health-indicator {
      transform: scale(0.98); // Counter the parent scaling
    }
  }
}

.box-card-table.risk {
  box-shadow: 0px 0px 8px #F4433660;
}
.box-card-table.recovery {
  box-shadow: 0px 0px 8px #66BB6A80;
}
.health-indicator {
  width: 18px;
  height: 18px;
  position: absolute;
  z-index: 100;
  left: -10px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}
.noti-count {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  background-color:transparent;
  color: white;
  font-family: 'Lato';
  border: 0px;
  //border-radius: 50%;
  line-height: 20px;
  text-align: center;
}
.imgProfilehouse{
  width: 20px;
  height: 20px;
}
.bar-contariner {
    .bar {
      border-radius: 6px;
      width: 6px;
      height: 18px;
      margin-right: 2px;
      background-color: rgba($color: #000000, $alpha: 0.1);
    }

    .bar-green {
      background-color: #35d077;
    }

    .bar-yellow {
      background-color: #fbc02d;
    }

    .bar-red {
      background-color: #f44336;
    }
  }

  .section-break {
  height: 20px;
  width: 1px;
  background-color: rgba(#000, 0.1);
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}
.txtName,
.txtTeam {
  color: #3c3c3c;
  width: 130px;
}
.progress-wrapper {
  position: relative;
  width: 26px;
  height: 26px;
  display: inline-block;
  vertical-align: middle;
}

.imgProfile {
  width: 44px;
  height: 44px;
  border-radius: 44px;
}

.profilepic {
  position: relative
}

.profilepic .noti-count {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  background-color:transparent;
  color: white;
  font-family: 'Lato';
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
}
.score-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 500;
  color: #000;
  text-align: center;
  z-index: 2;
  text-align: center;
  line-height: 24px;
  /* Adjust this if you change the .progress-wrapper dimensions */
  white-space: nowrap;
  /* Prevents the label from wrapping to the next line */
}

.percentile-type {
  font-size: 12px;
  opacity: 0.7;
}

.el-dropdown-link {
  color: #000000;
  
  &:hover {
    color: #6c30cc;
  }
}

</style>
<style lang="scss">
#insightsPeople .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #f5f5f580;
  cursor: pointer;

  .buttom-detail-image {
    opacity: 1;
  }
}

#insightsPeople div.showOption>ul>li>div {
  height: 40px !important;
  line-height: 40px !important;
}

#insightsPeople .el-table th>.cell {
  /* color: #2E2E2E; */
  font-size: 14px;
}

#insightsPeople .el-table td {
  padding: 0px 0px 0px 0px;
}

.dropdownItem-insightsPeople {
  overflow-y: auto;
  max-height: 228px;

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #6c30cc;
    border-color: #6c30cc;
  }
}

.el-checkbox__input.is-focus span.el-checkbox__inner,
span.el-checkbox__inner:hover {
  border-color: #dcdfe6;
}

.el-checkbox__input.is-checked.is-focus span.el-checkbox__inner {
  border-color: #6c30cc;
}

.el-checkbox__input {
  zoom: 1.5;
}

.el-dropdown-link {
  cursor: default;
  color: transparent;
}

.el-tooltip__popper.is-light {
  box-shadow: 0 0 12px 0 #00000052;
  border-width: 0;

  >.popper__arrow {
    border-width: 0;
    box-shadow: 0px 0px 6px 2px #00000052;
  }
}

.el-tooltip__popper.is-dark {
  max-width: 280px;
}

.el-select-dropdown__item:hover {
  background-color: #6C30CC30;
  color: #6C30CC;
  font-weight: 700;
}
</style>
